import axios, { AxiosError } from 'axios';
import { Environment } from '../../../../environment';
import { Api } from '../../axios-config';

import { v4 as uuidv4 } from 'uuid';

export interface IListagemFerias {
  idferias: string;
  idfun: string;
  datainicial: Date;
  datafinal: Date;
  periodo: string;
  valorinss: number;
  status: boolean;
}

export interface IFerias {
  idfun: string;
  datainicial: Date;
  datafinal: Date;
  valorinss: number;
}

export interface IFeriasUpdate {
  datainicial: Date;
  datafinal: Date;
  valorinss: number;
}


type TCeiComTotalCount = {
    data: IListagemFerias[];
    totalCount: number;
}

interface ErrorResponse {
  error: {
    default: string;
  };
}

const getAll = async (page = 1, idfun = ''): Promise<TCeiComTotalCount | Error> => {
  try {
    const urlRelativa = `/ferias?page=${page}&limit=${Environment.LIMITE_DE_LINHAS1}&idfun=${idfun}`;
    const { data, headers } = await Api.get(urlRelativa);
    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || Environment.LIMITE_DE_LINHAS1),
      };
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const create = async (dados: IFerias): Promise<string | Error> => {
  try {
    const guuid = uuidv4();
    const { data } = await Api.post<IFerias>('/ferias',  {idferias: guuid, ...dados});
    if (Object.keys(data).length === 0) {
      return guuid;
    }
    return new Error('Erro ao criar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const deleteById = async (id: string): Promise<void | Error> => {
  try {
    await Api.delete(`/ferias/${id}`);
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const updateById = async (id: string, dados: IFeriasUpdate): Promise<void | Error> => {
  try {
    await Api.put(`/ferias/${id}`, dados);
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

export const FeriasService = {
  getAll,
  create,
  deleteById,
  updateById,
}; 